/*************************************************/
/* COLLAPSED TEXT                                */
/*************************************************/
import customEventsNames from './../customEventsNames';

export function collapsedText() {
    const collapsedTextClass = "collapsed-text--collapsed";
    const collapsedTextButtonSelector = ".collapsed-text__button";

    const toggleCollapsedText = (button) => {
        // The collapsed content element is the one right before the button
        const collapsedTextField = button.previousElementSibling;

        if (!collapsedTextField) return;

        // Check the current state
        const isCollapsed = collapsedTextField.classList.contains(collapsedTextClass);

        if (isCollapsed) {
            // **OPEN/EXPAND**
            collapsedTextField.style.height = collapsedTextField.scrollHeight + 'px';
            collapsedTextField.classList.remove(collapsedTextClass);
            collapsedTextField.setAttribute('aria-expanded', 'true');

        } else {
            // **CLOSE/COLLAPSE**
            collapsedTextField.style.height = '0px';
            collapsedTextField.classList.add(collapsedTextClass);
            collapsedTextField.setAttribute('aria-expanded', 'false');
        }
    };

    const init = function () {
        var collapsedTextButtons = document.querySelectorAll(collapsedTextButtonSelector);

        collapsedTextButtons.forEach(button => {
            button.addEventListener('click', e => {
                // Pass the button element to the toggle function
                toggleCollapsedText(e.currentTarget);
            });
        });
    };

    init();
}